import { useState } from "react";
import { AlertOctagon, CheckSquare, HelpCircle } from "react-feather";
import { Card, CardBody, Col } from "reactstrap";
import { Alerts, Btn, P } from "../../../AbstractElements";
import { LeftBorderAlertTitle } from "../../../Constants/Constants";
import { LeftBorderAlertSubTitle } from "../../../Data/UiKits/Alert";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const LeftBorderAlert = () => {
  const [alertsVisibility, setAlertsVisibility] = useState({firstAlert: true,secondAlert: true,thirdAlert: true});
  const closeAlert = (alertKey: string) => setAlertsVisibility((prevState) => ({ ...prevState, [alertKey]: false }));

  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={LeftBorderAlertTitle} span={LeftBorderAlertSubTitle} />
        <CardBody className="live-dark">
          {alertsVisibility.firstAlert && (
            <Alerts color="light-dark" className="light alert-dismissible fade show text-dark border-left-dark">
              <HelpCircle />
              <P>{"You can check in on some of those fields below."}</P>
              <Btn color="transperant" close onClick={() => closeAlert("firstAlert")} />
            </Alerts>
          )}
          {alertsVisibility.secondAlert && (
            <Alerts color="light-secondary" className="light alert-dismissible fade show text-secondary border-left-secondary">
              <AlertOctagon />
              <P>{"Secondary Alert: border-left-secondary."}</P>
              <Btn color="transperant" close onClick={() => closeAlert("secondAlert")} />
            </Alerts>
          )}
          {alertsVisibility.thirdAlert && (
            <Alerts color="light-success" className="light alert-dismissible fade show text-success border-left-success">
              <CheckSquare />
              <P>{"Success Alert: border-left-success"}</P>
              <Btn color="transperant" close onClick={() => closeAlert("thirdAlert")} />
            </Alerts>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default LeftBorderAlert;
